@for (toast of wdxToastService.toasts; track $index) {
    <ngb-toast
        [autohide]="toast.autohide"
        [header]="toast.header"
        [ngClass]="
            (toast.severity ? 'toast-' + toast.severity : '') +
            (toast.classname ? ' ' + toast.classname : '')
        "
        [delay]="toast.delay || 5000"
        (hidden)="wdxToastService.remove(toast)"
        (mouseenter)="toast.autohide = false"
        (mouseleave)="toast.autohide = true"
    >
        <div class="d-flex align-items-center">
            <div class="flex-grow-1">
                @if (toast.isTemplate) {
                    <ng-container
                        *ngTemplateOutlet="
                            $any(toast).body;
                            context: getTemplateContext(toast)
                        "
                    ></ng-container>
                } @else {
                    <div class="d-flex align-items-center">
                        @if (!toast.header) {
                            @if (toast.throbber) {
                                <wdx-spinner
                                    class="toast-throbber d-block position-relative me-2"
                                    [themeColor]="toast.themeColor!"
                                    [small]="true"
                                ></wdx-spinner>
                            }
                            @if (!toast.throbber && toast.severity) {
                                <wdx-icon
                                    class="icon-shift-down align-self-start me-1"
                                    [icon]="toast.icon"
                                    [fixedWidth]="true"
                                ></wdx-icon>
                            }
                        }
                        <div>
                            @for (line of $any(toast).body; track $index) {
                                @if (toast.bodyRouterLink) {
                                    <a
                                        class="text-decoration-underline"
                                        data-cy="wdx-toast-link"
                                        [routerLink]="toast.bodyRouterLink"
                                        [queryParams]="toast.bodyQueryParams"
                                    >
                                        {{ line }}
                                    </a>
                                }
                                @if (!toast.bodyRouterLink) {
                                    <div
                                        data-cy="wdx-toast-text"
                                        [innerHTML]="
                                            line
                                                | translateTokenisedString
                                                | markdownToHtml
                                                | safeHtml
                                        "
                                    ></div>
                                }
                            }
                        </div>
                    </div>
                }
            </div>
            @if (!toast.hideCloseOnBody && !toast.header) {
                <div class="flex-shrink-0 align-self-start">
                    <wdx-icon-button
                        class="ms-4"
                        data-cy="wdx-toast-close-btn"
                        aria-label="Close"
                        [severity]="toast.severity"
                        (wdxOnClick)="wdxToastService.remove(toast)"
                    >
                        <wdx-icon icon="times"></wdx-icon>
                    </wdx-icon-button>
                </div>
            }
        </div>
    </ngb-toast>
}
